
import { BusinessUnitAddressMetadataBase } from './business-unit-address.metadata.base';


export class BusinessUnitAddressMetadata extends BusinessUnitAddressMetadataBase {
  constructor() {
    super();
  }
}

export const BUSINESS_UNIT_ADDRESS_METADATA: BusinessUnitAddressMetadata = new BusinessUnitAddressMetadata();


